import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus, faTrash, faUndoAlt } from "@fortawesome/free-solid-svg-icons";

const Busca = props => {
    const initialFieldSearch = {
        field: '',
        operator: 'contains',
        value: ''
    }

    const dictOperators = {
        equal: "Igual",
        contains: "Contém",
        not_contains: "Não contém"
    }

    const [fieldsSearch, setFieldsSearch] = useState([{ ...initialFieldSearch }]);

    const buscar = () => {
        const _fieldsSearch = clearInvalidFields([...fieldsSearch]);
        if (_fieldsSearch.length > 0) {
            props.service.buscar(_fieldsSearch);
        }
    }

    const reset = () => {
        setFieldsSearch([{ ...initialFieldSearch }]);
        props.service.buscar([{ ...initialFieldSearch }]);
        
    }

    const clearInvalidFields = fields => {
        for (let i = 0; i < fields.length; i ++) {
            if (fields[i].value === "" || fields[i].field === "") {
                fields.splice(i,1);
                return clearInvalidFields(fields);
            }
        }

        return fields;
    }

    const getFieldsSearchCombo = () => {
        return props.config.search.map(e => ({ label: e.label, field: e.field }));
    }

    const setField = (field, i) => {
        const _fieldsSearch = [...fieldsSearch];
        _fieldsSearch[i].field=field; 
        setFieldsSearch(_fieldsSearch);
    }

    const setOperator = (operator, i) => {
        const _fieldsSearch = [...fieldsSearch];
        _fieldsSearch[i].operator=operator; 
        setFieldsSearch(_fieldsSearch);
    }

    const setValue = (value, i) => {
        const _fieldsSearch = [...fieldsSearch];
        _fieldsSearch[i].value=value; 
        setFieldsSearch(_fieldsSearch);
    }

    const renderOperatorsByField = (field) => {
        const operators = props.config.search.filter(e => (e.field === field));
        if (operators.length > 0) {
            return operators[0].operators.map((o, i) => {
                return (
                    <option key={i} value={o}>{dictOperators[o]}</option>
                )
            })
        } else {
            return (
                <option value="">Selecione um campo</option>
            )
        }
    }

    const addFieldSearch = () => {
        const _fieldsSearch = [...fieldsSearch];
        const f = { ...initialFieldSearch }
        _fieldsSearch.push(f);
        setFieldsSearch(_fieldsSearch);
    }

    const renderFieldsOptions = (field) => {
        const options = getFieldsSearchCombo();
        return options.map((o, i) => {
            return (
                <option key={i} value={o.field}>{o.label}</option>
            )
        })
    }

    const renderSearchFields = () => {
        return fieldsSearch.map((f, i) => {
            return (
                <div className="item" key={i}>
                    <select className="field" value={f.field} onChange={(e) => setField(e.target.value, i)} >
                        <option value="">Campo</option>
                        {renderFieldsOptions(f.field)}
                    </select>
                    <select className="operator" onChange={(e) => setOperator(e.target.value, i)}>
                        {renderOperatorsByField(f.field)}
                    </select>
                    <input type="text" onChange={(e) => setValue(e.target.value, i)} value={f.value} placeholder="Digite aqui sua pesquisa..." />
                    <button type="button" onClick={() => removeField(i)}><FontAwesomeIcon icon={faTrash} /></button>
                </div>
            );
        })
    }

    const removeField = i => {
        const _fieldsSearch = [...fieldsSearch];
        _fieldsSearch.splice(i, 1);
        setFieldsSearch(_fieldsSearch);
    }

    return (
        <div className="form">
            <div className="fields">
                {renderSearchFields()}
            </div>
            <button type="submit" onClick={() => buscar()}><FontAwesomeIcon icon={faSearch} /></button>
            <button type="button" onClick={() => reset()}><FontAwesomeIcon icon={faUndoAlt} /></button>
            <button type="button" onClick={() => addFieldSearch()}><FontAwesomeIcon icon={faPlus} /> Filtro</button>
        </div>
    );
}

export default Busca;